import client from './client';

/** Public candidate feedback by token (no auth required). */
export const getCandidateFeedback = (token) => client.get(`/api/feedback/${token}`);
